import { useUnifyAdminStore } from '../../AdminStore';
import { GridApi, ColumnApi } from 'ag-grid-community';
import { Button, BUTTON_VARIANTS, IconDelete } from 'cdk-radial';

export const CustomOutageDeleteRenderer = (): JSX.Element => {
    const setDeleteDialogOpen = useUnifyAdminStore(
      (state) => state.setDeleteDialogOpen
    );
    const onDeleteClick = (
      event: React.MouseEvent,
      params: { api: GridApi; columnApi: ColumnApi }
    ) => {
      setDeleteDialogOpen(true);
    };
  
    return (
      <Button
        icon={<IconDelete />}
        text="Delete"
        variant={BUTTON_VARIANTS.ICON}
        onClick={onDeleteClick}
      />
    );
};


export const CustomReleaseDeleteRenderer = (): JSX.Element => {
  const setReleaseDeleteDialogOpen = useUnifyAdminStore(
    (state) => state.setReleaseDeleteDialogOpen
  );
  const onDeleteClick = (
    event: React.MouseEvent,
    params: { api: GridApi; columnApi: ColumnApi }
  ) => {
    setReleaseDeleteDialogOpen(true);
  };

  return (
    <Button
      icon={<IconDelete />}
      text="Delete"
      variant={BUTTON_VARIANTS.ICON}
      onClick={onDeleteClick}
    />
  );
};


export const CustomLinkDeleteRenderer = (): JSX.Element => {
  const setLinkDeleteDialogOpen = useUnifyAdminStore(
    (state) => state.setLinkDeleteDialogOpen
  );
  const onDeleteClick = (
    event: React.MouseEvent,
    params: { api: GridApi; columnApi: ColumnApi }
  ) => {
    setLinkDeleteDialogOpen(true);
  };

  return (
    <Button
      icon={<IconDelete />}
      text="Delete"
      variant={BUTTON_VARIANTS.ICON}
      onClick={onDeleteClick}
    />
  );
};
